import { IRole } from '@/pages/Users/users.types.ts'
import { IOption } from '@/types/global.ts'
import { useMemo } from 'react'
import useRoles from '@/pages/Users/hooks/useRoles.ts'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  value: IRole['id']
  onChange: (val: IRole['id'], name: string) => void
  name: string
  title?: string
}

const RoleDropdown = (props: IProps) => {
  const { roles } = useRoles()

  const options: IOption<IRole['id']> = useMemo(() => {
    return roles.map((r) => ({ value: r.id, title: r.name })) as any
  }, [roles])

  return (
    <DropdownInput
      options={options as any}
      selectedOption={props.value as any}
      title={props.title || 'Выберите роль'}
      onSelect={props.onChange}
      name={props.name}
    />
  )
}

export default RoleDropdown
